function ReferentSelfcare(data){
    let referent = data || {};
    this.id = referent.id;
    this.email = referent.email;
    this.gender = referent.gender === '0' ? undefined: referent.gender;
    this.firstName = referent.firstName;
    this.lastName = referent.lastName;
    this.birthDate = referent.birthDate === '0001-01-01T00:00:00Z' ? undefined: new Date(referent.birthDate);
    this.representativeType = referent.representativeType === '0' ? undefined: referent.representativeType;
    this.representedFirstName = referent.representedFirstName;
    this.representedLastName = referent.representedLastName;
    this.address = referent.address !== undefined ? referent.address : undefined;
    this.phoneNumber = referent.phoneNumber;
    this.representedRelation = referent.representedRelation;
    this.createdByRepresentative = referent.representedCreatedByRepresentative;
}
module.exports = ReferentSelfcare;